@if(invoice){
  <div class="invoice-summary">
    <div class="summary-card">
      <h3>Invoice Summary</h3>

      <div class="summary-row">
        <span class="label">Invoice Number:</span>
        <span class="value">{{ invoice.invoiceMetadata.invoiceNumber }}</span>
      </div>

      <div class="summary-row">
        <span class="label">From:</span>
        <span class="value">{{ invoice.companyInfo.name }}</span>
      </div>

      <div class="summary-row">
        <span class="label">To:</span>
        <span class="value">{{ invoice.clientInfo.name }}</span>
      </div>

      <div class="summary-row">
        <span class="label">Status:</span>
        <span class="status" [ngClass]="'status-' + invoice.status">
          {{ invoice.status | uppercase }}
        </span>
      </div>

      <hr>

      <div class="summary-row total">
        <span class="label">Total:</span>
        <span class="value">{{ invoice.companyInfo.address.countryCurrency }} {{ invoice.financialDetails.totalAmount| number: '1.2-2' }}</span>
      </div>
    </div>
  </div>
}